// Membersihkan HTML yang dibaca kembali dari penyimpanan (riwayat). Soal yang tersimpan
// dibuat oleh aplikasi sendiri, tetapi siapa pun yang login bisa mengirim data, jadi
// elemen dan atribut berbahaya dibuang sebelum ditampilkan.
const TAG_DILARANG = 'script,iframe,object,embed,link,meta,base,form,input,button,textarea,select,style,foreignObject,animate,set';

export function sanitasiHTML(html) {
  if (typeof html !== 'string' || !html) return '';
  const t = document.createElement('template');
  t.innerHTML = html;
  t.content.querySelectorAll(TAG_DILARANG).forEach(el => el.remove());
  t.content.querySelectorAll('*').forEach(el => {
    for (const a of [...el.attributes]) {
      const n = a.name.toLowerCase(), v = a.value.trim().toLowerCase();
      if (n.startsWith('on')) el.removeAttribute(a.name);
      else if ((n === 'href' || n === 'xlink:href' || n === 'src') && !(v.startsWith('#') || v.startsWith('/api/content/') || v.startsWith('data:image/'))) el.removeAttribute(a.name);
    }
  });
  return t.innerHTML;
}

// Bersihkan semua teks HTML di dalam satu soal.
const teksPolos = v => (typeof v === 'string' ? v : '');
// Gambar teks bacaan hanya dari konten aplikasi sendiri (R2) atau data URL gambar (mode demo).
const gambarAman = g => g && typeof g.src === 'string' && (/^\/api\/content\/gambar\/[a-z0-9][a-z0-9._-]*$/i.test(g.src) || /^data:image\/(png|jpeg|webp);base64,[a-z0-9+/=]+$/i.test(g.src));
export function sanitasiSoal(q) {
  const s = sanitasiHTML;
  const langkah = x => ({
    ...(x.t ? { t: s(x.t) } : {}), ...(x.v ? { v: s(x.v) } : {}), ...(x.after ? { after: s(x.after) } : {}), ...(x.lebar ? { lebar: true } : {}),
    ...(x.ask ? { ask: Array.isArray(x.ask.opsi) ? { q: s(x.ask.q), opsi: x.ask.opsi.map(s), a: Number(x.ask.a) } : { q: s(x.ask.q), a: Number(x.ask.a), ...(x.ask.u ? { u: s(x.ask.u) } : {}) } } : {}),
  });
  const b = q.bacaan && typeof q.bacaan === 'object' ? q.bacaan : null;
  return {
    ...q,
    text: s(q.text), vis: s(q.vis), title: s(q.title), el: String(q.el || ''),
    options: Array.isArray(q.options) ? q.options.map(o => typeof o === 'string' ? s(o) : { t: s(o?.t), v: !!o?.v, ...(o?.w ? { w: s(o.w) } : {}) }) : q.options,
    statements: Array.isArray(q.statements) ? q.statements.map(x => ({ t: s(x?.t), v: !!x?.v, ...(x?.w ? { w: s(x.w) } : {}) })) : q.statements,
    labels: Array.isArray(q.labels) && q.labels.length === 2 ? q.labels.map(x => s(teksPolos(x))) : undefined,
    steps: Array.isArray(q.steps) ? q.steps.map(langkah) : [],
    rumus: Array.isArray(q.rumus) ? q.rumus.filter(r => typeof r === 'string') : [],
    // Teks bacaan & bukti disimpan sebagai teks polos (di-escape saat ditampilkan).
    bacaan: b ? { id: teksPolos(b.id), jenis: teksPolos(b.jenis), judul: teksPolos(b.judul), teks: teksPolos(b.teks), bentuk: b.bentuk === 'puisi' ? 'puisi' : 'prosa', ...(b.sumber ? { sumber: teksPolos(b.sumber) } : {}), ...(gambarAman(b.gambar) ? { gambar: { src: b.gambar.src, alt: teksPolos(b.gambar.alt), posisi: Number.isInteger(b.gambar.posisi) ? b.gambar.posisi : 0 } } : {}) } : undefined,
    why: Array.isArray(q.why) ? q.why.map(w => s(teksPolos(w))) : undefined,
    bukti: Array.isArray(q.bukti) ? q.bukti.filter(x => typeof x === 'string') : undefined,
    gen: typeof q.gen === 'string' ? q.gen : undefined,
  };
}
